var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 45 45"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19382",
  transform: "translate(-1589 -523)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 22.5,
  "data-name": "Ellipse 1557",
  transform: "translate(1589 523)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15189"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1597 531h30v30h-30z",
  "data-name": "Rectangle 6401"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 14646",
  transform: "translate(1602.918 535.229)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.163 9.081c0 3.337-4.02 8.388-6.711 11.4a3.175 3.175 0 0 1-4.742 0C4.02 17.473 0 12.422 0 9.081a9.082 9.082 0 0 1 18.163 0",
  "data-name": "Path 16664"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.414,
  cy: 2.414,
  r: 2.414,
  "data-name": "Ellipse 1544",
  transform: "translate(6.668 6.668)"
}))))));
export { SvgChatLocation as ReactComponent };
export default __webpack_public_path__ + "static/media/chat_location.f56ee3a3aeb5d8c77572d04488e7ae98.svg";